export async function saveSetupDetails(client, userId, project, { name, note }) {
  if (!userId || !project?.id || project.user_id !== userId) throw new Error('Sign in as the setup owner to save details.')
  const fields = { setup_pattern: name.trim(), setup_notes: note, updated_at: new Date().toISOString() }
  let query = client.from('position_projects').update(fields).eq('id', project.id).eq('user_id', userId)
  // Compare only the fields we own. Broker updates must not block a journal edit.
  for (const key of ['setup_pattern', 'setup_notes']) {
    query = project[key] == null ? query.is(key, null) : query.eq(key, project[key])
  }
  const { data, error } = await query.select('id, setup_pattern, setup_notes, updated_at').single()
  if (error || !data?.id) throw new Error('Details could not be saved. Refresh to check for changes, then retry. Your draft is still here.')
  return data
}

export function percentStopPrice(entry, draft) {
  const text = String(draft).trim().replace(/\s+/g, '')
  if (!/^-\d+(?:\.\d+)?%?$/.test(text)) throw new Error('Enter a negative percentage such as -7.5, then press Enter.')
  const percent = Math.abs(Number(text.replace('%', '')))
  const price = Number(entry)
  if (!Number.isFinite(price) || price <= 0) throw new Error('Enter a positive entry price first.')
  if (!(percent > 0 && percent < 100)) throw new Error('Stop percentage must be between 0 and 100.')
  const result = (price * (1 - percent / 100)).toFixed(2)
  if (Number(result) <= 0 || Number(result) >= price) throw new Error('This percentage does not produce a valid stop at cent precision.')
  return result
}
